import './index.scss'

$(document).ready(function(){
  if($('#search-circle-ani').length > 0){
    // 监听circle-ani 是否有class:is-inview
    var mo = new MutationObserver(function(records){
      if($(records[0].target).hasClass('is-inview')){
        var t1 = getRandomInt(50, 90);
        var r1 = getRandomInt(0, 50);
        var t2 = getRandomInt(100, 200);
        var r2 = getRandomInt(20, 50);
        $('#search-circle-ani .circle-bg-img.circle1').css({top: t1+'%',right: r1+'%'})
        $('#search-circle-ani .circle-bg-img.circle2').css({top: t2+'%',right: r2+'%'})
      }
    });
    
    var element = document.getElementById('search-circle-ani');
    mo.observe(element, {'attributes': true});
  }

  $('.form-right .icon').on('click',function(){
    $('.form-right').addClass('show-all')
  })
})


// 生成随机数
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}



